import { render, staticRenderFns } from "./login.vue?vue&type=template&id=12f4dd8a&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "../college/logo-layout.css?vue&type=style&index=0&id=12f4dd8a&prod&scoped=true&lang=css&external"
import style1 from "./login.vue?vue&type=style&index=1&id=12f4dd8a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f4dd8a",
  null
  
)

export default component.exports